class CustomEventEmitter {
  constructor() {
    this.addCustomListerner = (event, callback) => {
      document.addEventListener(event, (data) => {
        callback(data.detail);
      });
    };
    this.removeCustomListener = (event, callback) => {
      document.removeEventListener(event, callback);
    };
    this.dispatchEvent = (type, data) => {
      const event = new CustomEvent(type, {
        detail: data,
        bubbles: true,
        cancelable: true,
        composed: false,
      });
      document.dispatchEvent(event);
    };
    this.getCartItems = (callback) => {
      this.removeCustomListener('getCartItems', callback);
      this.addCustomListerner('getCartItems', callback);
    };
  }
}

export default new CustomEventEmitter();
